/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import fi from './fi.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    resources: {
      en,
      fi,
    },
    interpolation: {
      escapeValue: false,
    },
    ns: ['common'],
    defaultNS: 'common',
  });

export default i18n;
